import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface SuggestionsSourceSettings extends MemorySearchSettings {
  type: 'suggestions';
}
